module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Clothes/Shorts-a9c0c7cc96b8133dfab7d48f4a58bccd.svg";